import { render, staticRenderFns } from "./template.vue?vue&type=template&id=e1c5c9f8&scoped=true&"
import script from "@/Components/Modules/CheckList/AddonSetup/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Modules/CheckList/AddonSetup/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Modules/CheckList/AddonSetup/style.scss?vue&type=style&index=0&id=e1c5c9f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c5c9f8",
  null
  
)

export default component.exports